var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('ml-table',{ref:"operationLogTableRef",attrs:{"title":"操作日志","url":_vm.$API.log_page_post,"defaultConfig":_vm.listTableConfig,"mountQuery":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }